import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LOGOUT } from "./authActionTypes";

interface SpecialAccessState {
  usernames: string[];
  isLoaded: boolean;
}

const initialState: SpecialAccessState = {
  usernames: [],
  isLoaded: false,
};

const specialAccessSlice = createSlice({
  name: "SpecialAccess",
  initialState,
  reducers: {
    setSpecialAccessUsernames: (state, action: PayloadAction<string[]>) => {
      state.usernames = action.payload;
      state.isLoaded = true;
    },
    clearSpecialAccessUsernames: state => {
      state.usernames = [];
      state.isLoaded = false;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      action => action.type === LOGOUT,
      state => {
        state.usernames = [];
        state.isLoaded = false;
      }
    );
  },
});

export const {
  setSpecialAccessUsernames,
  clearSpecialAccessUsernames,
} = specialAccessSlice.actions;

export default specialAccessSlice.reducer;
